import { useDataLoader } from "2g-hooks/fetch";

import { ADMIN } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useZdroj({ id }) {
  return useDataLoader({
    url: ADMIN.zdroj(id),
    method: "get",
    lazy: isEmpty(id),
    ignoreNotFound: true
  });
}
